import { ICommand } from 'core-ts-types';
import { NavigationBarAlertService } from 'ui-ng-navbar';

export function MyHoldsRoutes($stateProvider: any) {
  $stateProvider
    .state('my.holdscenter', {
      url: 'hold-center/',
      templateUrl: 'capability-ng-holds/src/views/holds_center/holds_center.html',
      data: {
        viewTitle: 'Active Holds',
        hasMainMenu: true,
        ignoredInHistory: false
      },
      onEnter: (loadHoldsCommand: ICommand) => {
        loadHoldsCommand();
      }
    })
    .state('my.holdsdetail', {
      templateUrl: 'capability-ng-holds/src/views/holds_detail/holds_detail.html',
      controller: 'HoldsDetailController',
      controllerAs: '$ctrl',
      url: 'hold-detail/:holdTypeId/:id/',
      data: {
        viewTitle: 'Hold Detail',
        suppressTrackingPage: true,
        ignoredInHistory: false
      },
      params: {
        additionalInfo: undefined
      },
      onExit(ngNavigationBarAlertService: NavigationBarAlertService) {
        ngNavigationBarAlertService.reset();
      }
    });
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-holds/src/routes.ts